import "./Auth.scss";
import React, { useState } from "react";
import { authImg, logo, textImg } from "assets/images";
import { Button, Input } from "components/form";
import { validateOnlyNumber } from "utils/commonHelper";
import { removeErrorFields, validateInput } from "validation";
import useButtonLoader from "hooks/useButtonLoader";
import { auth } from "validation/schema/auth";
import { sendVerifyOtp } from "services/auth";
import CustomModal from "components/modals/CustomModal";
import OTPScreen from "./OTPScreen";
import { toastMessage } from "utils/toastMessageHelper";
import { constant } from "constant/constantValue";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  // hook
  const [resetButtonLoader, setResetButtonLoader] =
    useButtonLoader("Reset Password");
  const { t } = useTranslation();

  // Set value
  const [inputData, setInputData] = useState({
    isRegister: true,
  });
  const [error, setError] = useState({});
  const [verificationModal, setVerificationModal] = useState(false);

  // change handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    const newValue = name === "mobile" ? validateOnlyNumber(value) : value;
    setInputData({ ...inputData, [name]: newValue });

    setError((prevError) => removeErrorFields(prevError, name));
  };

  // input validation
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "forgotPasswordSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // close OTP modal
  const closeModal = () => {
    setVerificationModal(false);
  };

  // Forget Password Send OTP handler
  const sendForgetVerificationOtpHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setResetButtonLoader(true);

        const { message = "", status } = await sendVerifyOtp(inputData);
        if (status === 200) {
          setVerificationModal(true);
          toastMessage(message, "success", "sendForgetVerifyOtp");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setResetButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="auth_page">
        <div className="image_section">
          <img src={logo} alt="" className="logo" />
          {/* <img src={authImg} alt="" className="side_img" /> */}
          <img src={textImg} alt="" className="text_img" />
        </div>
        <div className="auth_form">
          <form>
            <div className="form_title">
              <h3>{t("FORGETPASSWORD.forgetPassword")}</h3>
              <p>{t("FORGETPASSWORD.forgetPasswordDescription")}</p>
            </div>
            <div className="form_field has_country_code">
              <Input
                type="text"
                placeholder={t("FORGETPASSWORD.enterMobileNumber")}
                label={t("FORGETPASSWORD.mobileNumber")}
                name="mobile"
                value={inputData?.mobile}
                onChange={changeHandler}
                error={error?.mobile}
                extraError={error?.mobileErr}
                maxLength={constant.MOBILE_LENGHT}
              />
              <span className="country_code">+966 | </span>
            </div>

            <div className="button_wrap">
              <Button
                className="button"
                ref={resetButtonLoader}
                onClick={sendForgetVerificationOtpHandler}
              >
                {t("FORGETPASSWORD.resetPassword")}
              </Button>
            </div>
          </form>
        </div>
      </div>

      {/* otp verificaton for forget password */}
      {verificationModal && (
        <CustomModal
          show={verificationModal}
          handleClose={closeModal}
          className={"otpModal"}
        >
          <OTPScreen
            type="login"
            inputData={inputData}
            closeModal={closeModal}
            setInputData={setInputData}
          />
        </CustomModal>
      )}
    </>
  );
};

export default ForgotPassword;
